export default __webpack_public_path__ + "static/media/34_3_0.8de269ca.png";